import React, { PropTypes } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, getFormValues, reduxForm } from "redux-form";

import { SelectInput } from "../../../common/form";
import { intlShape } from "react-intl";

import { MEMBERS, FOLLOW_UP_CATEGORIES } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";

const formName = "followUpsFilter";

class FollowUpsFilter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fetching: false,
    };

    this.getMembers = this.getMembers.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.getDataList(
      FOLLOW_UP_CATEGORIES,
      0,
      0,
      "",
      ["followUpCategoryOrder:asc"],
      [FOLLOW_UP_CATEGORIES.categorizeFilter]
    );
  }

  getMembers(query) {
    const offset = 0;
    const limit = 20;
    const q = query;
    const sortBy = ["firstName:asc", "lastName:asc"];
    const filters = [MEMBERS.notArchivedFilter];
    const headers = null;
    const metadata = {};
    const fields =
      "memberId,memberIdentifier,firstName,lastName,client(fullName)";
    const sectionType = "";
    const additionalParams = { qFields: "firstName,lastName" };

    this.setState({ fetching: true });
    this.props.dataActions
      .getDataList(
        MEMBERS,
        offset,
        limit,
        q,
        sortBy,
        filters,
        headers,
        metadata,
        fields,
        sectionType,
        additionalParams
      )
      .then(() => {
        this.setState({ fetching: false });
      });
  }

  onChange(event) {
    const { fields, onChange, deactivateCheckboxes } = this.props;
    deactivateCheckboxes();
    fields[event.target.name] = event.target.value;
    onChange(fields);
  }

  render() {
    const { options } = this.props;
    const categories = this.props.followUpCategoryList
      .sort((a, b) => a.followUpCategoryOrder - b.followUpCategoryOrder)
      .map((category) => {
        return {
          value: category.followUpCategoryId,
          text: category.localizations[this.props.languageCode].name,
        };
      });

    let searchValues = [];

    searchValues = searchValues.concat(options[0]).concat(categories);

    for (let i = 1; i < options.length; i++) {
      searchValues = searchValues.concat(options[i]);
    }

    return (
      <div className="datatable-filter">
        <Field
          id="followUpsFilter"
          name="followUpsFilter"
          component={SelectInput}
          searchable={true}
          options={searchValues}
          props={{ onChange: this.onChange }}
          sortOptions={false}
        />
      </div>
    );
  }
}

FollowUpsFilter.propTypes = {
  change: PropTypes.func.isRequired,
  dataActions: PropTypes.object,
  fields: PropTypes.object,
  members: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  followUpCategoryList: PropTypes.array.isRequired,
  languageCode: PropTypes.string.isRequired,
  resetFilter: PropTypes.bool,
  deactivateCheckboxes: PropTypes.func
};

FollowUpsFilter.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const members = state.data.members || {};
  const followUpCategoryData = state.data.followUpCategories || {};
  const languageCodeData = state.auth.user.languageCode || "en-CA";
  return {
    fields: getFormValues(formName)(state),
    members: members.items || [],
    followUpCategoryList: followUpCategoryData.items || [],
    languageCode: languageCodeData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: formName,
  })(FollowUpsFilter)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/list/FollowUpsFilter.js